module.exports = __webpack_public_path__ + "img/aeroland-payment-hero-bg-pink.725365da.jpg";